package com.essntl.features.proposal.domain.model

sealed class ProposalOrderType(val orderName: String) {
    data object Alphabetical : ProposalOrderType("Alphabetical")

    data object LastCreated : ProposalOrderType("Last Created")

    data object StartDate : ProposalOrderType("Start Date")

    data object RecentlyChanged : ProposalOrderType("Last modified")

    companion object {
        val Default = LastCreated
    }
}
